import { fetcher } from "@/lib/fetcher";
import { useMemo } from "react";
import useSWRMutation from "swr/mutation";

export function useOTP() {
  const { trigger: sendOTP } = useSWRMutation(
    "/nxapi/send-otp",
    async function (_, { arg }: { arg: Record<string, any> }) {
      return await fetcher("/nxapi/send-otp", {
        method: "POST",
        body: JSON.stringify(arg),
        headers: {
          "Content-Type": "application/json",
        },
      });
    }
  );

  const { trigger: validateOTP } = useSWRMutation(
    "/nxapi/validate-otp",
    async function (_, { arg }: { arg: Record<string, any> }) {
      return await fetcher("/nxapi/validate-otp", {
        method: "POST",
        body: JSON.stringify(arg),
        headers: {
          "Content-Type": "application/json",
        },
      });
    }
  );

  return useMemo(
    () => ({
      sendOTP,
      validateOTP,
    }),
    [sendOTP, validateOTP]
  );
}
